import { css } from "styled-components"
import { LayoutStyles as GameLayoutStyles } from "./game/game-styles"

export const LayoutStyles = css`
  &.page-game {
    ${GameLayoutStyles}
  }
`
